import React, { ReactNode } from 'react';

import { Typography, Row, Col } from 'antd';

import TitleCopy from '@/components/TitleCopy';

const { Title } = Typography;

const PageTitle = (props: {
  title: string | ReactNode;
  copy?: string;
  tag?: ReactNode;
}) => (
  <Row gutter={[16, 16]}>
    <Col
      xs={24}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        paddingTop: '1.5rem',
      }}
    >
      <Title style={{ margin: '0' }}>{props.title}</Title>
      {props.tag}
    </Col>
    {props.copy && (
      <Col xs={24} sm={12}>
        <TitleCopy>{props.copy}</TitleCopy>
      </Col>
    )}
  </Row>
);

export default PageTitle;
